import React, { useState, useEffect } from "react";
import { getNextAppointmentDate } from "../../tools/dates";
import Loader from './Loader';

const ClinicNextAppointment = ( { id, type }) => {

    const [ nextAppointment, setNextAppointment ] = useState(null);
    const [ loading, setLoading ] = useState(true);

    useEffect( () => {

        if( !id || !type ) {
            return false;
        }

        fetch(`/cd/feeds/booking-journey/appointments/${id}/${type}/1`)
        .then(response => response.json())
        .then(data => {

            if(data) {
                setNextAppointment(getNextAppointmentDate(data));
            }

            setLoading(false);
            
        });
        

    }, []);

    return (
        <div className="next-appointment">
            <span className="next-appointment__label">Next appointment:</span>
            <a href={`/booking-journey/?clinicID=${id}`} className="next-appointment__badge badge">
                { loading ? (
                    <Loader/>
                ) : <>
                    { nextAppointment ? (
                        <>{ nextAppointment }</>
                    ) : <>NA</> }
                </> }
            </a>
        </div>
    )
}

export default ClinicNextAppointment;